import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
// import { CaptureUrl } from '@blade-sxp/search-center/interfaces/index';
import { allTrack, cleanAll, deleteTrack } from '@blade-sxp/search-center/api/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import { searchStore } from '@blade-sxp/search-center/store/search';
let AlarmCenter = class AlarmCenter extends Vue {
    allNum;
    isClose;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    // selectedImg: Array<CaptureUrl> = [];
    clearNum = 0;
    deleteImageUrl = require('@blade-sxp/search-center/assets/images/del.png');
    get selectedImg() {
        return searchStore.selectedImg;
    }
    clearAlltrack() {
        cleanAll().then((res) => {
            // this.selectedImg = res;
            searchStore.updateSelectedImg(res);
            this.$emit('deletedNum', this.clearNum);
            // this.showPopover();
        });
    }
    deleteImg(imageId, item) {
        deleteTrack(imageId).then((res) => {
            this.$emit('deletedNum', res, item);
            // this.showPopover();
        });
    }
    showPopover() {
        allTrack().then((res) => {
            // this.selectedImg = res;
            searchStore.updateSelectedImg(res);
        });
    }
};
__decorate([
    Prop()
], AlarmCenter.prototype, "allNum", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "isClose", void 0);
AlarmCenter = __decorate([
    Component({
        name: 'popover',
        components: { BlurPicture },
        i18n: { sharedMessages: langMsg },
    })
], AlarmCenter);
export default AlarmCenter;
